import { render, staticRenderFns } from "./AtePlatTestingExam.vue?vue&type=template&id=2857bbde"
import script from "./AtePlatTestingExam.vue?vue&type=script&lang=js"
export * from "./AtePlatTestingExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports